import { useLocation } from 'js/lib/useRouter';

import { browseAllSubjectsButtonProps, domainButtonProps } from 'bundles/composable-page-header/constants';

const useEnterpriseNavButtons = () => {
  const location = useLocation();
  const baseUrl = location.pathname.split('/').slice(0, 3).join('/');
  const subjectsButtons = [...domainButtonProps(), browseAllSubjectsButtonProps()];

  const navButtons = subjectsButtons.map((button) => ({
    ...button,
    href: `${baseUrl}/${button.name}`,
  }));

  return navButtons;
};

export default useEnterpriseNavButtons;
